const storageKey = "themeViewer";

export { storageKey };